import React, { createContext, useContext } from "react";
import { useCustomSiteQuery } from "./services/customSiteQueries";

// Define the shape of the props
interface SiteDataProviderProps {
  slug: string;
  children: React.ReactNode;
}

// Define the shape of the context
interface SiteDataContextType {
  data: any;
  error: Error | null;
  isLoading: boolean;
}

// Create context with a default value
const SiteDataContext = createContext<SiteDataContextType | null>(null);

// SiteDataProvider Component
export const SiteDataProvider: React.FC<SiteDataProviderProps> = ({ slug, children }) => {
  const { data, error, isLoading  } = useCustomSiteQuery(slug);

  return (
    <SiteDataContext.Provider value={{ data, error, isLoading }}>
      {children}
    </SiteDataContext.Provider>
  );
};

// Custom Hook to consume site data and states
export const useSiteData = () => {
  const context = useContext(SiteDataContext);
  if (!context) {
    throw new Error("useSiteData must be used within a SiteDataProvider");
  }
  return context;
};
